export enum CounterType {
  FeedIn = 0, //0 
  Producer = 1, //1 
  Consumer = 2, //2
  FeedOut = 3, //3
  }